export function calculateScore(fullScore: number, percentage: number, digits = 2) {
  const clampedPercentage = Math.max(0, Math.min(100, percentage));
  const clampedFullScore = Math.max(0, fullScore);
  const score = (clampedPercentage / 100) * clampedFullScore;
  return score.toFixed(digits);
}
